<template src="./template.html"></template>

<script>
import { isNull } from 'lodash'

export default {
  name: 'EditTopicOverlay',
  props: {
    isOpen: Boolean,
    topic: Object,
  },
  data() {
    return {
      title: '',
      description: '',
    }
  },
  computed: {
    opened: {
      set() {
        this.$emit('onCloseOverlay')
      },
      get() {
        return this.isOpen
      },
    },
  },
  created() {
    this.title = this.topic.infos.title
    this.description = this.topic.infos.description
  },
  methods: {
    onSubmit() {
      this.$emit('submit', {
        title: this.title,
        description: this.description,
      })
    },
    isNotNull() {
      return !isNull(this.topic.infos && this.topic.infos.img)
    },

  },
}
</script>
